import React from 'react';

export default function Templates() {
  return (
    <div style={{ padding: '28px 32px' }}>
      <h1 style={{ fontSize: '1.4rem', color: 'var(--admin-text)', fontWeight: 600, marginBottom: 6 }}>
        Template-Editor
      </h1>
      <p style={{ fontSize: '.82rem', color: 'var(--admin-text-dim)' }}>
        Das Template-System wurde entfernt. Design-Tokens werden direkt in <code>App.css</code> gepflegt.
      </p>
    </div>
  );
}
